<template>
  <div class="container">
    <div class="row pt-5">
      <div class="col">
        <div class="float-start">
          <!-- การขาย / ใบเสนอราคาสำหรับ{บุคคล|ครอบครัว} -->
          <h4 v-html="quotationBreadcrumb"></h4>
        </div>
        <!-- (ซ่อน:เฉพาะสำหรับครอบครัว) [ ] นำเสนอขายนอกสถานที่ -->
        <div class="float-end" :hidden="!isInsuranceTypePersonal">
          <div class="offside-sale-checkbox">
            <OffsideSaleCheck v-model="isOffsideSaleQuotationPersonal"></OffsideSaleCheck>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-5">
      <!-- 1. ข้อมูลของผู้ขอเอาประกันภัย -->
      <InsuredForm
        :typeInsurance="typeInsurance"
        :quotationId="quotationId"
        :disabledForm="isDisabledForm"
      />
      <!-- 2. ข้อมูลส่วนบุคคลของผู้ชำระเบี้ยประกันภัย -->
      <PayerForm
        :typeInsurance="typeInsurance"
        :quotationId="quotationId"
        :disabledForm="isDisabledForm"
      />
      <!-- 3. รายละเอียดผู้รับผลประโยชน์ -->
      <BeneficiaryForm
        :typeInsurance="typeInsurance"
        :quotationId="quotationId"
        :disabledForm="isDisabledForm"
      />
      <!-- (ซ่อน) ตารางผลประโยชน์และเบี้ยประกันภัย กรมธรรม์ประกันภัยสุขภาพและอุบัติเหตุส่วนบุคคล -->
      <div v-show-slide="isShowInsurancePlan" class="table-plan-container">
        <InsuranceTablePlan2
          :isFamilyType="typeInsurance === 'family'"
          :insurancePlan="insurancePlan"
          :insuredAge="insuredAge"
          :disabledForm="isDisabledForm"
          :isShowExtra="isShowExtraPlan"
        />
      </div>
      <!-- 4. ข้อมูลบุคคลอ้างอิง (Referral) -->
      <ReferralForm
        :typeInsurance="typeInsurance"
        :quotationId="quotationId"
        :disabledForm="isDisabledForm"
      />
      <!-- 5. ข้อมูลผู้เสนอขาย -->
      <SaleForm />
      <!-- (ซ่อน) ปุ่มเลือกแผน -->
      <div
        v-if="!isShowInsurancePlan && isValidatePayerSuccess"
        class="select-insurance-plan-btn text-center pb-5"
      >
        <Button @click.native="getInsurancePlan">เลือกแผนประกัน</Button>
      </div>
      <!-- (ซ่อน) ปุ่มบันทึกและย้อนกลับ -->
      <div v-if="isShowInsurancePlan" class="quotation-submit-btn-container clearfix pb-5">
        <!-- Backward button -->
        <router-link
          :to="`/insurance_family/${familyId}`"
          target="_self"
          v-if="typeInsurance === 'family' || familyId"
        >
          <Button theme="outline" class="btn btn-dark btn-print pull-left m-r-xs">
            กลับไปหน้าจัดการสมาชิก
          </Button>
        </router-link>
        <!-- Submit quotation form button-->
        <div v-if="!isDocumentCompleted" class="pull-right">
          <div class="go-to-application-form-btn">
            <Button @click.native="validateQuotationForm">บันทึก/กรอกใบคำขอ</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Validator } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import * as _ from 'lodash'

import '@/styles/spacing.css'
import '@/styles/float.css'
import Button from '@/components/Button'
import Modal from '@/components/Modal'
import InsuredForm from '@/components/Form/InsuredForm'
import PayerForm from '@/components/Form/PayerForm'
import BeneficiaryForm from '@/components/Form/BeneficiaryForm'
import SaleForm from '@/components/Form/SaleForm'
import ReferralForm from '@/components/Form/ReferralForm'
import InsuranceTablePlan2 from '@/components/Table/InsuranceTablePlan2/InsuranceTablePlan2'
import { packagePlanType } from '@/lib/global'
import OffsideSaleCheckbox from '@/components/Checkbox/OffsideSaleCheckbox'
import PayerForm2 from '@/components/Form/PayerForm2.vue'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})
const { mapFields: mapReferrerFields } = createHelpers({
  getterType: 'getReferrerFields',
  mutationType: 'updateReferrerFields',
})

export default {
  components: {
    OffsideSaleCheck: OffsideSaleCheckbox,
    Button,
    Modal,
    InsuredForm,
    PayerForm: PayerForm2,
    BeneficiaryForm,
    SaleForm,
    ReferralForm,
    InsuranceTablePlan2,
  },
  name: 'QuotationPersonal',
  props: ['typeInsurance'],
  data() {
    return {
      isShowInsurancePlan: false,
      familyId: '',
      quotationBreadcrumb: this.getQuotationBreadcrumb(this.typeInsurance),
      isInsuranceTypePersonal: _.eq(this.typeInsurance, 'personal'),
      isOffsideSaleQuotationPersonal: false,
    }
  },
  methods: {
    ...mapActions([
      'getQuotationInformation',
      'getReferrerInformation',
      'getNamePrefix',
      'getInsurancePlanInformation',
      'getInsuranceDeductPlanInformation',
      'updateQuotationInformation',
      'fetchIsOffsideSaleQuotation',
    ]),
    onTriggerPackagePlanChange: _.debounce(function () {
      const { isCheckOPD, isCheckHIB, isCheckCancer, isCheckCI, opdType } = this.insurancePlan
      const age = this.insuredCustomerInformation.age

      const IPD = 'IPD+PA'
      const OPD = isCheckOPD ? opdType : ''
      const HIB = isCheckHIB ? packagePlanType.HIB : ''
      const CANCER = isCheckCancer ? packagePlanType.CANCER : ''
      const CI = isCheckCI ? packagePlanType.CI : ''

      const packagePlanArr = [IPD, OPD, HIB, CANCER, CI]
      const filteredNoValue = _.filter(packagePlanArr, (val) => {
        const isValueEmpty = _.isEmpty(val)
        const isValueNull = _.isNull(val)

        return !(isValueEmpty || isValueNull)
      })

      const coverageCodes = _.join(filteredNoValue, '+')

      this.getInsurancePlanInformation({ coverageCodes, age: this.isZeroAge ? 1 : age })
    }, 200),
    getInsurancePlan() {
      const age = this.insuredCustomerInformation.age

      this.getInsurancePlanInformation({ age: this.isZeroAge ? 1 : age })
      this.getInsuranceDeductPlanInformation(this.isZeroAge ? 1 : age)
    },
    checkFamilyDiscountCondition(familyQuotation, insuredAge) {
      const familyMembers = familyQuotation.familyMembers
      const familyDiscount = familyQuotation.discount
      const familyQuotations = familyQuotation.quotations

      const isAllFamilyPersonFilledInformation = _.chain(familyQuotations)
        .filter((data) => data.age)
        .size()
        .isEqual(familyMembers)
        .value()

      const currentInsuredChild = !isAllFamilyPersonFilledInformation && insuredAge < 16 ? 1 : 0
      const currentInsuredAdult = !isAllFamilyPersonFilledInformation && insuredAge >= 16 ? 1 : 0

      const child =
        _.chain(familyQuotations)
          .filter((quotation) => (quotation.age ? quotation.age < 16 : false))
          .size()
          .value() + currentInsuredChild
      const adult =
        _.chain(familyQuotations)
          .filter((quotation) => (quotation.age ? quotation.age >= 16 : false))
          .size()
          .value() + currentInsuredAdult

      if (familyDiscount === 5) {
        if (familyMembers === 2) {
          return !(child > 1 || adult > 2)
        }

        if (familyMembers === 3) {
          return !(child > 2 || adult > 1)
        }

        return false
      }

      if (familyDiscount === 10) {
        if (familyMembers === 3) {
          return !(child > 1)
        }

        if (familyMembers > 3) {
          return !(child > 2)
        }

        return false
      }

      return true
    },
    validateQuotationForm() {
      const { planType, deductible } = this.insurancePlan

      if (!planType) {
        this.$swal({
          type: 'error',
          title: 'กรุณาเลือกแผนประกัน',
        })
      } else if (!deductible) {
        this.$swal({
          type: 'error',
          title: 'กรุณาเลือกส่วนลด',
        })
      } else if (this.isHasReferrer) {
        this.validator.validateAll(this.referrerData).then((validationResult) => {
          if (validationResult) {
            this.saveQuotationInformation()
          }
        })
      } else {
        this.saveQuotationInformation()
      }
    },
    saveQuotationInformation() {
      const { planType, deductible } = this.insurancePlan
      const { insuredId } = this.insuredDetailInformation
      const { payerId, isPaidByInsuredPerson } = this.payerInformation
      const { type, firstPerson, secondPerson } = this.beneficiaryInformation

      const coveragePlanInformation = _.get(
        this.insurancePlanInformationData,
        'coveragePlanInfo.plans',
        [],
      )
      const planPackageSchemeId = _.find(
        coveragePlanInformation,
        (plan) => plan.planId === planType,
      ).schemeId

      const data = {
        isBeneficiaryLegalHeir: type === 'heir',
        beneficiaryInfo1: {
          namePrefix: firstPerson.namePrefix,
          firstname: firstPerson.firstname,
          lastname: firstPerson.lastname,
        },
        beneficiaryInfo2: {
          namePrefix: secondPerson.namePrefix,
          firstname: secondPerson.firstname,
          lastname: secondPerson.lastname,
        },
        plan: {
          schemeId: planPackageSchemeId,
          deductibleId: deductible,
        },
        referrerInfo: {
          staffId: this.referrerStaffId,
          firstname: this.referrerFirstname,
          lastname: this.referrerLastname,
          branchId: this.referrerBranchId,
        },
        isOffsideSale: this.isOffsideSaleQuotationPersonal,
      }

      this.updateQuotationInformation({
        quotationId: this.quotationId,
        data,
      })
    },
    clearErrors() {
      this.referrerValidationErrors.clear()
    },
    setRule() {
      this.validator = new Validator(this.referrerValidationRules)
      this.$set(this, 'referrerValidationErrors', this.validator.errors)
    },
    getQuotationBreadcrumb: function (typeInsurance) {
      const quotationType = _.eq(typeInsurance, 'family') ? 'ครอบครัว' : 'บุคคล'
      return `การขาย / <span class=\"text-success active\">ใบเสนอราคาสำหรับ${quotationType}</span>`
    },
  },
  watch: {
    insurancePlanInformationData() {
      if (this.insurancePlanInformationData) {
        this.isShowInsurancePlan = true

        const planPackageSchemeId = _.get(
          this.quotationInformation,
          'planPackageScheme.schemeId',
          null,
        )

        if (planPackageSchemeId) {
          const coveragePlanInformation = _.get(
            this.insurancePlanInformationData,
            'coveragePlanInfo.plans',
            [],
          )
          this.insurancePlan.planType = _.find(
            coveragePlanInformation,
            (plan) => plan.schemeId === planPackageSchemeId,
          ).planId
        }
      }
    },
    'insurancePlan.isCheckOPD'() {
      if (this.insurancePlan.isCheckOPD) {
        if (this.insurancePlan.opdType) {
          this.onTriggerPackagePlanChange()
        } else {
          this.insurancePlan.opdType = 'OPD(Standard)'
        }
      } else {
        this.insurancePlan.opdType = ''
      }
    },
    'insurancePlan.isCheckHIB'() {
      this.onTriggerPackagePlanChange()
    },
    'insurancePlan.isCheckCancer'() {
      this.onTriggerPackagePlanChange()
    },
    'insurancePlan.isCheckCI'() {
      this.onTriggerPackagePlanChange()
    },
    'insurancePlan.opdType'() {
      if (this.insurancePlan.opdType) {
        this.insurancePlan.isCheckOPD = true
      }

      this.onTriggerPackagePlanChange()
    },
    quotationInformation: {
      handler(data) {
        this.familyId = _.get(data, 'familyQuotation.familyId', '')

        const planPackageSchemeId = _.get(data, 'planPackageScheme.schemeId', null)

        if (planPackageSchemeId) {
          const coverageCode = _.get(data, 'planPackageScheme.coverageCode', null)
          const age = _.get(data, 'insuredPerson.age', null)

          const { OPD_DELUXE, OPD_STANDARD, HIB, CANCER, CI } = packagePlanType

          const isOpdDeluxe = _.includes(coverageCode, OPD_DELUXE)
          const isOpdStandard = _.includes(coverageCode, OPD_STANDARD)
          const isCheckOPD = isOpdDeluxe || isOpdStandard
          const isCheckHIB = _.includes(coverageCode, HIB)
          const isCheckCancer = _.includes(coverageCode, CANCER)
          const isCheckCI = _.includes(coverageCode, CI)
          const opdType = _.includes(coverageCode, OPD_STANDARD) ? OPD_STANDARD : OPD_DELUXE

          this.insurancePlan = {
            ...this.insurancePlan,
            opdType: isCheckOPD ? opdType : null,
            isCheckOPD,
            isCheckHIB,
            isCheckCancer,
            isCheckCI,
          }

          this.getInsurancePlanInformation({
            coverageCodes: coverageCode,
            age: this.isZeroAge ? 1 : age,
          })
          this.getInsuranceDeductPlanInformation(this.isZeroAge ? 1 : age)

          this.isShowInsurancePlan = true
        }
      },
      deep: true,
    },
    'insuredCustomerInformation.age'(age) {
      if (this.typeInsurance === 'family') {
        const familyInformation = this.quotationInformation.familyQuotation
        const familyQuotations = _.get(this.quotationInformation, 'familyQuotation.quotations', [])
        const currentFamilyQuotation = _.find(
          familyQuotations,
          (quotation) => quotation.quotationId === this.quotationId,
        )

        const relationshipId = currentFamilyQuotation.relationshipId
        const isFamilyDiscountConditionCorrected = this.checkFamilyDiscountCondition(
          familyInformation,
          age,
        )

        if (!isFamilyDiscountConditionCorrected) {
          this.$swal({
            type: 'error',
            title:
              'ขออภัย รายละเอียดสมาชิกในกลุ่มของท่าน ไม่ตรงกับเงื่อนไขการได้รับส่วนลดของบริษัทฯ สอบถามเพิ่มเติม กรุณาติดต่อ 0-2695-0800 ต่อ 2951 หรือ 2949 Email : support_tmbhcp@thaivivat.co.th',
            allowOutsideClick: false,
          }).then(() => {
            const familyId = _.get(this.quotationInformation, 'familyQuotation.familyId', null)

            return this.$router.push(`/insurance_family/${familyId}`)
          })
        }
      }
    },
    isOffsideSalePersonal: function (value) {
      this.isOffsideSaleQuotationPersonal = value
    },
  },
  computed: {
    ...mapGetters(['insurancePlanInformationData', 'deductibleInformationData']),
    ...mapQuotationFields({
      quotationId: 'quotationId',
      quotationInformation: 'quotationInformation.data',
      insuredCustomerInformation: 'insuredDetail.data.customerInformation',
      payerCustomerInformation: 'payerInformation.data.customerInformation',
      isValidatePayerSuccess: 'payerInformation.data.isValidateInformationSuccess',
      insuredDetailInformation: 'insuredDetail.data',
      payerInformation: 'payerInformation.data',
      beneficiaryInformation: 'beneficiary',
      insurancePlan: 'insurancePlan',
      isDisabledForm: 'isDisabledForm',
    }),
    ...mapReferrerFields({
      referrerData: 'data',
      isHasReferrer: 'data.isHasReferrer',
      referrerStaffId: 'data.staffId',
      referrerFirstname: 'data.firstname',
      referrerLastname: 'data.lastname',
      referrerBranchId: 'data.branchId',
      referrerValidationRules: 'validation.rules',
      referrerValidationErrors: 'validation.errors',
    }),
    insuredAge() {
      return _.get(this.insuredCustomerInformation, 'age', 0)
    },
    isZeroAge() {
      return this.insuredAge === 0
    },
    isDocumentCompleted() {
      const documentProcessStatus = _.get(
        this.quotationInformation,
        'documentProcessStatus.id',
        null,
      )

      return documentProcessStatus === 3
    },
    isHasPlanPackageSchemeId() {
      const planPackageSchemeId = _.get(
        this.quotationInformation,
        'planPackageScheme.schemeId',
        null,
      )

      return Boolean(planPackageSchemeId)
    },
    isShowExtraPlan() {
      const insuredAge = this.insuredAge

      if (this.typeInsurance === 'family' && insuredAge < 16) {
        const familyQuotations = _.get(this.quotationInformation, 'familyQuotation.quotations', [])

        const isAllClassicPlan = _.chain(familyQuotations)
          .filter((quotation) => quotation.planId)
          .every((quotation) => quotation.planId === 'P001')
          .value()

        return _.size(familyQuotations) ? !isAllClassicPlan : true
      }

      return true
    },
  },
  mounted() {
    this.getNamePrefix()

    this.quotationId = this.$route.params.quotation_id

    if (this.quotationId) {
      const { quotationId: id } = this
      this.getQuotationInformation(id)
      this.fetchIsOffsideSaleQuotation(id)
    }
  },
  created() {
    this.setRule()
  },
}
</script>

<style lang="scss">
.offside-sale-checkbox {
  position: relative;
  right: -1rem;
}

.quotation-submit-btn-container {
  .send-email-quotation-btn-container,
  .go-to-application-form-btn {
    display: inline-block;
  }

  .send-email-quotation-btn-container {
    .send-email-quotation-btn {
      .mail-icon {
        margin-right: 8px;
      }
    }
  }

  .go-to-application-form-btn {
    margin-left: 12px;
  }
}

.email-quotation-container {
  .modal-container {
    padding: 40px;
    width: 80%;
  }

  .email-quotation-content-section {
    margin-bottom: 16px;

    .email-icon-container {
      color: #27ae60;
      font-size: 64px;
      margin-bottom: 16px;
      text-align: center;
    }

    .email-text-container {
      text-align: center;

      .highlight-text {
        color: #27ae60;
      }
    }
  }

  .email-confirm-btn-container {
    text-align: center;
  }
}
</style>
